import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useState, useEffect, useRef } from 'react';

var cubicBezier = function cubicBezier(p0, p1, p2, p3, t) {
  return Math.pow(1 - t, 3) * p0 + 3 * Math.pow(1 - t, 2) * t * p1 + 3 * (1 - t) * Math.pow(t, 2) * p2 + Math.pow(t, 3) * p3;
};

var animationCurve = function animationCurve(t) {
  return cubicBezier(0.02, 0.75, 0.5, 1, t);
};

var animationDuration = 250;
export var useScroll = function useScroll(scrollContainerRef, scrollContentsRef) {
  var dependencies = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      canScrollBackward = _useState2[0],
      setCanScrollBackward = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      canScrollForward = _useState4[0],
      setCanScrollForward = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      contentsOverflow = _useState6[0],
      setContentsOverflow = _useState6[1];

  var updateShouldScroll = useCallback(function () {
    if ((scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current) && (scrollContentsRef === null || scrollContentsRef === void 0 ? void 0 : scrollContentsRef.current)) {
      var outerWidth = scrollContainerRef.current.clientWidth;
      var innerWidth = scrollContentsRef.current.offsetWidth;
      var scrollStart = scrollContainerRef.current.scrollLeft;
      var hasStartOverflow = scrollStart !== 0;
      var hasEndOverflow = Math.abs(scrollStart) < innerWidth - outerWidth;
      setContentsOverflow(hasStartOverflow || hasEndOverflow);
      setCanScrollBackward(hasStartOverflow);
      setCanScrollForward(hasEndOverflow);
    }
  }, [scrollContainerRef, scrollContentsRef]);
  useEffect(updateShouldScroll, [scrollContainerRef, scrollContentsRef, updateShouldScroll].concat(_toConsumableArray(dependencies))); // Update for any resizes or content changes

  useEffect(function () {
    var observer = new MutationObserver(updateShouldScroll);
    window.addEventListener('resize', updateShouldScroll);
    var container = null;

    if (scrollContainerRef.current) {
      observer.observe(scrollContainerRef.current, {
        subtree: true,
        childList: true,
        characterData: true
      });
      container = scrollContainerRef.current;
      scrollContainerRef.current.addEventListener('scroll', updateShouldScroll);
    }

    return function () {
      observer.disconnect();
      window.removeEventListener('resize', updateShouldScroll);
      container === null || container === void 0 ? void 0 : container.removeEventListener('scroll', updateShouldScroll);
    };
  }, [scrollContainerRef, updateShouldScroll]);
  var frameId = useRef(null);
  var scrollBy = useCallback(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        offsetTop = _ref.top,
        offsetLeft = _ref.left;

    if (!scrollContainerRef.current) return;
    if (frameId.current) cancelAnimationFrame(frameId.current);
    var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

    if (isSmoothScrollSupported) {
      scrollContainerRef.current.scrollBy({
        top: offsetTop,
        left: offsetLeft,
        behavior: 'smooth'
      });
    } else {
      var _scrollContainerRef$c = scrollContainerRef.current,
          startTop = _scrollContainerRef$c.scrollTop,
          startLeft = _scrollContainerRef$c.scrollLeft;
      var startTime = Date.now();

      var updateScroll = function updateScroll() {
        var _a;

        var deltaTime = Date.now() - startTime;
        var linearProgress = Math.min(deltaTime, animationDuration) / animationDuration;
        var curvedProgress = animationCurve(linearProgress);
        (_a = scrollContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(_objectSpread({}, offsetTop !== undefined && {
          top: startTop + offsetTop * curvedProgress
        }, {}, offsetLeft !== undefined && {
          left: startLeft + offsetLeft * curvedProgress
        }));
        frameId.current = linearProgress < 1 ? requestAnimationFrame(updateScroll) : null;
      };

      frameId.current = requestAnimationFrame(updateScroll);
    }
  }, [scrollContainerRef]);
  var scrollIntoView = useCallback(function (target) {
    if (target.current && scrollContainerRef.current) {
      scrollBy({
        left: target.current.offsetLeft - scrollContainerRef.current.scrollLeft,
        top: target.current.offsetTop - scrollContainerRef.current.scrollTop
      });
    }
  }, [scrollBy, scrollContainerRef]);
  return {
    canScroll: contentsOverflow,
    canScrollBackward: canScrollBackward,
    canScrollForward: canScrollForward,
    scrollBy: scrollBy,
    scrollIntoView: scrollIntoView
  };
};